"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _history = require("history");
var Boilerplate = window.cccisd.boilerplate;
var _default = exports["default"] = (0, _history.createBrowserHistory)({
  basename: Boilerplate.settings.currentUri
});